import { FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";

import personOne from "@assets/img/avatars/person-1.png";
import personTwo from "@assets/img/avatars/person-2.png";
import personThree from "@assets/img/avatars/person-3.png";
import { Card } from "@components/cards/card";

type PublicProfile = {
  name: string;
  followers: string;
  avatar: string;
};

const publicProfiles: PublicProfile[] = [
  {
    name: "@anacarolina",
    followers: "12,4 mil seguidores",
    avatar: personOne,
  },
  {
    name: "@rafaelsantos",
    followers: "8,7 mil seguidores",
    avatar: personTwo,
  },
  {
    name: "@julicosta",
    followers: "5,1 mil seguidores",
    avatar: personThree,
  },
];

export function PublicProfilesSection() {
  return (
    <section id="recursos" className="landing-profiles-section py-5">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6">
            <span className="badge bg-secondary bg-opacity-10 rounded-pill px-3 py-2 mb-3 fs-6">
              {"Afilia\u00e7\u00f5es Comissionadas"}
            </span>
            <div className="landing-profiles-grid row g-3">
              {publicProfiles.map(({ name, followers, avatar }) => (
                <div className="col-6 col-md-4" key={name}>
                  <Card className="landing-profile-card h-100 border shadow-sm p-3 text-center">
                    <img
                      className="landing-profile-avatar rounded-circle mb-2"
                      src={avatar}
                      alt={`Perfil de ${name}`}
                    />
                    <div className="fw-bold small text-dark text-truncate">
                      {name}
                    </div>
                    <small className="text-muted d-block text-truncate">
                      {followers}
                    </small>
                    <div className="d-flex justify-content-center gap-2 my-3">
                      <FaInstagram className="fs-4 text-danger" title="Instagram" />
                      <FaTiktok className="fs-4 text-dark" title="TikTok" />
                      <FaYoutube className="fs-4 text-danger" title="YouTube" />
                    </div>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm rounded-3 w-100"
                      disabled
                    >
                      Seguir
                    </button>
                  </Card>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-6">
            <div className="landing-profiles-copy">
              <span className="landing-profiles-badge badge rounded-pill px-3 py-2 mb-3">
                Descubra novos talentos
              </span>
              <h2 className="landing-profiles-title fw-bold mb-3">
                {"Perfis p\u00fablicos para serem encontrados"}
              </h2>
              <p className="landing-profiles-description mb-0">
                {"Usu\u00e1rios e influenciadores podem publicar suas redes sociais na plataforma para que donos de campanhas possam encontr\u00e1-los e fazer convites. "}
                <i>
                  {"Em breve ser\u00e1 poss\u00edvel seguir perfis e acompanhar suas atividades diretamente aqui na plataforma."}
                </i>
              </p>
              <p className="landing-profiles-description mt-2">
                {"Negocie comiss\u00f5es com amigos, conhecidos e influencers para que te ajudem a vender seus tickets/bilhetes e sejam comissionados, percentual negociado entre as partes, diretamente na conta deles."}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}